import { render, staticRenderFns } from "./booking-breadcrumb.vue?vue&type=template&id=3afd7b21&scoped=true&"
import script from "./booking-breadcrumb.vue?vue&type=script&lang=js&"
export * from "./booking-breadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./booking-breadcrumb.vue?vue&type=style&index=0&id=3afd7b21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afd7b21",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
